export const HOST_API = process.env.REACT_APP_API_ENDPOINT || "";
export const PORTAL_HOMEPAGE_URL = process.env.REACT_APP_PORTAL_HOMEPAGE_URL || "";
